import * as React from "react";
import {FormComponentProps} from "../../form/Form";
import isUndefined = require("lodash/isUndefined");
import {Ticket, TournamentRef} from "../../../../generated/protocol";

export interface TicketProps extends FormComponentProps {
    entity: any,
    buttonClass: string,
    onClick: (entity: Ticket) => void
}


export class TicketView extends React.Component<TicketProps, {}> {
    renderTournaments(label: string, tournaments: TournamentRef[]) {
        if (tournaments == null || isUndefined(tournaments) || tournaments.length == 0) {
            return <div/>;
        }
        else {
            return (
                <div className="linked-tournaments">
                    <div className="linked-tournaments-label">{label}</div>
                    <div className="tournaments-list">{tournaments.map(entity => <div key={entity.id}
                                                                                      className="tournament-ref">{entity.name} [{entity.id}]</div>)}</div>
                </div>
            );
        }
    }

    render() {
        let entity: any = this.props.entity;
        return (
            <div key={entity.nameId} className="ticket">
                <div className="ticket-name">
                    {entity.name}
                    <button className={this.props.buttonClass} onClick={(event) => {
                        event.preventDefault();
                        this.props.onClick(entity);
                    }}><i className="fa fa-chain-broken"></i></button>
                </div>
                {this.renderTournaments("Satellite Tournaments", entity.satellites)}
                {this.renderTournaments("Target Tournaments", entity.targets)}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/ui/poker/tournament/TicketView.tsx